// ============================================
// Kerrisdale Bootery - Sequential Size Sorting
// ============================================
(function() {
    function sortSizeFilters() {
        var sorted = false;
        document.querySelectorAll('.boost-sd__filter-option').forEach(function(filterBlock) {
            var title = filterBlock.querySelector('.boost-sd__filter-option-title');
            if (!title) return;

            var text = (title.textContent || '').toLowerCase();
            if (text.indexOf('size') === -1) return;

            var list = filterBlock.querySelector('.boost-sd__filter-option-listitem');
            if (!list) return;

            var items = Array.from(list.querySelectorAll(':scope > .boost-sd__filter-option-item'));
            if (items.length < 2) return;

            function sortKey(node) {
                var label = node.querySelector('.boost-sd__filter-option-item-label');
                var str = label ? (label.textContent || '').trim() : '';
                var num = parseFloat(str) || 0;

                var width = 0;
                if (/XW/i.test(str)) width = 3;
                else if (/(\d)\s*W/i.test(str) || /\.5W/i.test(str)) width = 2;
                else if (/US/i.test(str)) width = 1;

                var category = 0;
                if (/Toddler/i.test(str)) category = 1;
                else if (/Little\s*Kid/i.test(str)) category = 2;
                else if (/Youth/i.test(str)) category = 3;

                return { category: category, num: num, width: width };
            }

            items.sort(function(a, b) {
                var ka = sortKey(a);
                var kb = sortKey(b);
                if (ka.category !== kb.category) return ka.category - kb.category;
                if (ka.num !== kb.num) return ka.num - kb.num;
                return ka.width - kb.width;
            });

            items.forEach(function(item) { list.appendChild(item); });
            sorted = true;
        });
        return sorted;
    }

    // Wait for Boost to fully hydrate, then sort repeatedly to win the race
    var attempts = 0;
    var maxAttempts = 20;
    var checker = setInterval(function() {
        attempts++;
        sortSizeFilters();
        if (attempts >= maxAttempts) {
            clearInterval(checker);
            // Final observer: only re-sort when Boost re-renders after user interaction
            var debounceTimer;
            var observer = new MutationObserver(function(mutations) {
                // Only react to Boost filter re-renders, not our own sort
                var isBoostRender = mutations.some(function(m) {
                    return m.addedNodes.length > 0 && m.target.closest &&
                           m.target.closest('.boost-sd__filter-option-listitem');
                });
                if (isBoostRender) {
                    clearTimeout(debounceTimer);
                    debounceTimer = setTimeout(sortSizeFilters, 300);
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    }, 500);
})();
// ============================================
// ============================================
// Kerrisdale Bootery - Product Page Size Sorting
// ============================================
(function() {
    function sortProductSizes() {
        document.querySelectorAll('fieldset.variant-option--buttons').forEach(function(fieldset) {
            var legend = fieldset.querySelector('legend');
            if (!legend || legend.textContent.trim().toLowerCase() !== 'size') return;
            if (fieldset.dataset.sorted === 'true') return;

            var labels = Array.from(fieldset.querySelectorAll('label.variant-option__button-label'));
            if (labels.length < 2) return;

            function sortKey(label) {
                var input = label.querySelector('input[type="radio"]');
                var str = input ? (input.value || '').trim() : '';
                var num = parseFloat(str) || 0;

                var width = 0;
                if (/XW/i.test(str)) width = 3;
                else if (/(\d)\s*W/i.test(str) || /\.5W/i.test(str)) width = 2;
                else if (/US/i.test(str)) width = 1;

                var category = 0;
                if (/Toddler/i.test(str)) category = 1;
                else if (/Little\s*Kid/i.test(str)) category = 2;
                else if (/Youth/i.test(str)) category = 3;

                return { category: category, num: num, width: width };
            }

            labels.sort(function(a, b) {
                var ka = sortKey(a);
                var kb = sortKey(b);
                if (ka.category !== kb.category) return ka.category - kb.category;
                if (ka.num !== kb.num) return ka.num - kb.num;
                return ka.width - kb.width;
            });

            labels.forEach(function(label) { fieldset.appendChild(label); });
            fieldset.dataset.sorted = 'true';
        });
    }

    setTimeout(sortProductSizes, 500);
    setTimeout(sortProductSizes, 1500);
    setTimeout(sortProductSizes, 3000);

    document.addEventListener('DOMContentLoaded', function() {
        setTimeout(sortProductSizes, 500);
        setTimeout(sortProductSizes, 1500);
    });
})();
